import React from "react";

const SmartphonePreview = ({
  primaryColor,
  secondaryColor,
  backgroundColor,
  textPrimary,
  textSecondary,
  logoBase64,
  backgroundSmartphoneImage,
  backgroundImage,
}) => {
  return (
    <div
      style={{
        position: "relative",
        width: "390px",
        height: "844px",
        maxWidth: "100%",
        margin: "0 auto",
        backgroundColor: backgroundColor || "#f3f3f3",
        backgroundImage: backgroundSmartphoneImage
          ? `url(${backgroundSmartphoneImage})`
          : backgroundImage
          ? `url(${backgroundImage})`
          : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      {/* Header */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "60px",
          background: `linear-gradient(to right, ${
            primaryColor || "#01315f"
          }, ${secondaryColor || "#067ddb"})`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 15px",
        }}
      >
        {logoBase64 && (
          <img
            src={logoBase64}
            alt="Logo"
            style={{ height: "20px", objectFit: "contain" }}
          />
        )}
        <div style={{ color: "white", display: "flex", alignItems: "center" }}>
          <i className="fas fa-globe mr-1"></i> ES
        </div>
      </div>

      {/* Content area with background color overlay */}
      <div
        style={{
          position: "absolute",
          top: "60px",
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: backgroundColor || "#f3f3f3",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "15px",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: "90%" }}>
          <h2
            style={{
              color: textPrimary || "#01315f",
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
            }}
          >
            Título de ejemplo
          </h2>
          <p
            style={{
              color: textSecondary || "#01315f",
              fontSize: "12px",
              lineHeight: "1.4",
            }}
          >
            Este texto demuestra cómo el color de fondo con opacidad mejora la
            legibilidad sobre imágenes complejas.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SmartphonePreview;
